import $ from 'jquery';
import 'slick-carousel';

const gallery = () => {
    const $containers = $('.js-gallery');

    function init () {
        // If no gallery on the page
        if ($containers.length === 0) {
            // Stop the script
            return;
        }
        // Init Slick for each gallery
        $containers.each(function () {
            var options = {
                infinite: true,
                dots: true
            };

            // If only one item in the gallery
            if ($('.g-gallery__item', this).length === 1) {
                options.infinite = false;
                options.dots = false;
            }

            $('.js-gallery__list', this).slick({
                arrows: false,
                dots: options.dots,
                dotsClass: 'o-dots__list',
                appendDots: $('.js-gallery__dots', this),
                centerMode: true,
                infinite: options.infinite,
                centerPadding: '100px',
                variableWidth: true,
                focusOnSelect: true,
                responsive: [{
                    breakpoint: 700,
                    settings: {
                        centerPadding: '50px'
                    }
                }]
            });
        });
    }

    return {
        init: init
    }
};

export default gallery;
